<ng-container *ngIf="mode === prepSummaryMode.List; else table">
	<ul [ngClass]="columnCountClass" id="recipe-{{ id }}-prepSummary" [attr.aria-label]="label">
		<li *ngIf="prepDuration">
			<div>
				<cdx-svg-icon name="knife" fill="dark" size="small"></cdx-svg-icon>
				<p class="sr-only" i18n="@@recipes-preparationTime">Preparation time</p>
				{{ prepDuration | recipeTime }}
			</div>
		</li>
		<li *ngIf="cookDuration">
			<div>
				<cdx-svg-icon name="casserole" fill="dark" size="small"></cdx-svg-icon>
				<p class="sr-only" i18n="@@recipes-cookingTime">Cook time</p>
				{{ cookDuration | recipeTime }}
			</div>
		</li>
		<li *ngIf="serves">
			<div>
				<cdx-svg-icon name="bowl" fill="dark" size="small"></cdx-svg-icon>
				Serves {{ serves }}
			</div>
		</li>
	</ul>
</ng-container>
<ng-template #table>
	<ng-container *ngIf="prepDuration || cookDuration || serves">
		<table *ngIf="isMobile$ | async" id="recipe-{{ id }}-prepSummary" [attr.aria-label]="label">
			<thead>
				<tr>
					<th *ngIf="prepDuration || cookDuration">{{ prepAndCook }}</th>
					<th *ngIf="serves" i18n="@@recipes-servings">Servings</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td *ngIf="prepDuration || cookDuration">
						<div>
							<cdx-svg-icon name="casserole" fill="dark" size="extra-small"></cdx-svg-icon>
							<ng-container *ngIf="prepDuration">{{ prepDuration | recipeTime }}</ng-container>
							<ng-container *ngIf="prepDuration && cookDuration"> + </ng-container>
							<ng-container *ngIf="cookDuration">{{ cookDuration | recipeTime }}</ng-container>
						</div>
					</td>
					<td *ngIf="serves">
						<div>
							<cdx-svg-icon name="bowl" fill="dark" size="extra-small"></cdx-svg-icon>
							{{ serves }}
						</div>
					</td>
				</tr>
			</tbody>
		</table>
		<dl *ngIf="!(isMobile$ | async)" id="recipe-{{ id }}-prepSummary" [attr.aria-label]="label">
			<dt *ngIf="prepDuration || cookDuration">{{ prepAndCook }}</dt>
			<dd *ngIf="prepDuration || cookDuration">
				<div>
					<cdx-svg-icon name="casserole" fill="dark" size="extra-small"></cdx-svg-icon>
					<ng-container *ngIf="prepDuration">{{ prepDuration | recipeTime }}</ng-container>
					<ng-container *ngIf="prepDuration && cookDuration"> + </ng-container>
					<ng-container *ngIf="cookDuration">{{ cookDuration | recipeTime }}</ng-container>
				</div>
			</dd>
			<dt *ngIf="serves" i18n="@@recipes-servings">Servings</dt>
			<dd *ngIf="serves">
				<div>
					<cdx-svg-icon name="bowl" fill="dark" size="extra-small"></cdx-svg-icon>
					{{ serves }}
				</div>
			</dd>
		</dl>
	</ng-container>
</ng-template>
